import PropertyField from "../shared/PropertyField";
import { isHybridSale } from "../../../utilities/hybridSales";

/**
 * Detail fields shown when the selected property is a Tax / Deed / Certificate / etc. sale.
 */
export const TaxSaleDetails = ({
  selectedProperty,
  detailsResponse,
  minimumBid,
  displayLocation,
  isCancelled = false,
}) => (
  <>
    <PropertyField label="Sale ID">
      {selectedProperty.saleId ?? "N/A"}
      {isCancelled && (
        <span className="property-sale-cancelled-label"> — Sale Cancelled</span>
      )}
    </PropertyField>
    <PropertyField label="Parcel #" value={selectedProperty.propertyId} />
    <PropertyField label="Property ID" value={selectedProperty.propertyId} />
    <PropertyField label="Owner Name" value={detailsResponse?.propertyCardDetail?.ownerName1} />
    <PropertyField label="Brief Legal" value={selectedProperty.briefLegal} />
    <PropertyField
      label="Address"
      value={`${selectedProperty.address1}, ${selectedProperty.city}, ${selectedProperty.state} ${selectedProperty.zip}`}
    />
    <PropertyField label="Min. Bid" value={minimumBid} />
    <PropertyField label="Type">
      {isHybridSale(selectedProperty?.location)
        ? "Online Registration / In-Person Sale"
        : selectedProperty.type ?? "N/A"}
    </PropertyField>
    <PropertyField label="Location" value={displayLocation} />
  </>
);

/**
 * Detail fields shown when the selected property is a Foreclosure sale.
 */
export const ForeclosureDetails = ({
  selectedProperty,
  propertyDetails,
  minimumBid,
  displayLocation,
  showPurchasePrice,
}) => (
  <>
    <PropertyField label="Cause #" value={propertyDetails?.causeNumber} />
    <PropertyField label="Defendant" value={propertyDetails?.defendant} />
    <PropertyField label="Plaintiff" value={propertyDetails?.plantiff} />
    <PropertyField label="Attorney" value={propertyDetails?.attorney} />
    <PropertyField label="Judgment Amount" value={propertyDetails?.judgementAmount} />
    <PropertyField label="Min. Bid" value={minimumBid} />
    {showPurchasePrice && <PropertyField label="Purchase Price" value={propertyDetails?.salePrice} />}
    <PropertyField label="Type">
      {isHybridSale(selectedProperty?.location)
        ? "Online Registration / In-Person Sale"
        : selectedProperty.type ?? "N/A"}
    </PropertyField>
    <PropertyField label="Sale Location Address" value={displayLocation} />
    <PropertyField
      label="Property Address"
      value={`${selectedProperty.address1}, ${selectedProperty.city}, ${selectedProperty.state} ${selectedProperty.zip}`}
    />
  </>
);
